<template>
    <div v-if="edit_user" style="margin: -20px -20px 0 -20px;">
        <div class="card-header bg-white">
            <div class="d-flex">
                <div class="col-form-label mr-2">Datumintervall:</div>
                <div style="width: 400px;">
                    <v-select
                        :options="select_timecard_periods"
                        v-model="timecare_period"
                        :reduce="opt => opt.id"
                        :clearable="false"
                    ></v-select>
                </div>
                <div class="ml-auto text-right">
                    <limitless-button v-if="can_edit" @click="editTimecare(0)" :busy="busy_importing" icon="icon-plus3">Lägg till tidrad</limitless-button>
                </div>
            </div>
        </div>
        <div>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Börjat</th>
                    <th>Slutat</th>
                    <th>Butik IN</th>
                    <th>Butik UT</th>
                    <th style="text-align:right;">Rapporterad tid(t)</th>
                    <th style="text-align:right;">Rast(m)</th>
                    <th style="text-align:right;">Arbetad tid(t)</th>
                    <th style="text-align:right;">Frånvaro</th>
                    <th v-if="show_overtime" style="text-align:center;">Övertid</th>
                    <th v-if="can_approve" style="text-align:center;">Godkänd</th>
                    <th v-if="can_approve" style="text-align:center;">Överförd</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(time, t_idx) in timecares" :key="'t-' + t_idx" :style="{ 'color': (time.PayslipID>0 ? '#999999' : 'inherit') }">
                    <template v-if="can_edit">
                    <td>
                        <a href="" @click.prevent="editTimecare(time.TimeCareID)">{{ formatDateTime(time.TimeIN) }} {{ getDayName(time.TimeIN) }}</a> <span v-if="time.TimeIN!==time.TimeIN_org">*</span>
                    </td>
                    <td>
                        <a href="" @click.prevent="editTimecare(time.TimeCareID)">{{ formatDateTime(time.TimeOUT) }}</a> <span v-if="time.TimeOUT!==time.TimeOUT_org">*</span>
                    </td>
                    </template>
                    <template v-else>
                        <td>
                            {{ formatDateTime(time.TimeIN) }} {{ getDayName(time.TimeIN) }} <span v-if="time.TimeIN!==time.TimeIN_org">*</span></td>
                        <td>
                            {{ formatDateTime(time.TimeOUT) }} <span v-if="time.TimeOUT!==time.TimeOUT_org">*</span>
                        </td>
                    </template>
                    <td>{{ time.StoreNameIn }}</td>
                    <td>{{ time.StoreNameOut }}</td>
                    <td style="text-align:right;">
                        {{ (Math.round(parseFloat(time.TotalTime) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </td>
                    <td style="text-align:right;">
                        {{ (Math.round(parseFloat(time.BreakMinutes) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        <span v-if="time.BreakMinutes!==time.BreakMinutes_org">*</span>
                    </td>
                    <td style="text-align:right;" :style="{ 'color': (time.SickLeave ? 'red' : 'inherit') }">
                        {{ (Math.round(parseFloat(time.WorkedTime) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </td>
                    <td style="text-align:right;">
                        <span v-if="time.CauseCode === 'SJK'" style="color:red;">Sjuk</span>
                        <span v-else-if="time.CauseCode === 'SEM'">Semester</span>
                        <span v-else-if="time.CauseCode === 'VAB'">VAB</span>
                        <span v-else-if="time.CauseCode === 'FPE'">Föräldraledig</span>
                        <span v-else-if="time.CauseCode === 'PAP'">Pappadagar</span>
                        <span v-else-if="time.CauseCode === 'PEM'">Permission</span>
                        <span v-else-if="time.CauseCode === 'TJL'">Tjänstledig</span>
                        <span v-else>{{ time.CauseCode }}</span>
                    </td>
                    <td v-if="show_overtime" style="text-align:center;">
                        <div class="custom-control custom-checkbox d-inline-block">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="'timecare-overtime-' + time.TimeCareID"
                                v-model="time.overtime"
                                :true-value="1"
                                :false-value="0"
                                :disabled="saving_overtime_ids.includes(time.TimeCareID)"
                                @change="saveOvertime(time)"
                            >
                            <label class="custom-control-label" :for="'timecare-overtime-' + time.TimeCareID">
                                <span class="sr-only">Övertid</span>
                            </label>
                        </div>
                    </td>
                    <td v-if="can_approve" style="text-align:center;">
                        <i v-if="time.approved" class="icon-checkmark4 text-success"></i>
                        <button v-else-if="time.TimeOUT" class="btn btn-light btn-sm" @click="approveTime(time)">Godkänn</button>
                    </td>
                    <td v-if="can_approve" style="text-align:center;">
                        <span v-if="time.PayslipID>0">SpecID: {{ time.PayslipID }}</span>
                        <span v-if="(edit_user.FortnoxSalaryType !== 1 || time.overtime>0) && time.SentToFortnox>0"><i class="icon-checkmark4 text-success"></i></span>
                        <span v-else-if="time.SentToFortnox>0"><i class="icon-checkmark4 text-muted"></i></span>
                    </td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="bg-light border-top">
                    <th :colspan="timecare_table_columns" class="text-uppercase text-muted">Överfört</th>
                </tr>
                <tr>
                    <th colspan="6" style="text-align:right;">Summa Utbetalt:</th>
                    <th colspan="1" style="text-align:right;">{{ timecare_total_paid }}</th>
                    <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                </tr>
                <tr>
                    <th colspan="6" style="text-align:right;">Summa Ej Utbetalt:</th>
                    <th colspan="1" style="text-align:right;">{{ timecare_total_unpaid }}</th>
                    <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                </tr>
                <template v-if="show_overtime">
                    <tr class="bg-light border-top">
                        <th :colspan="timecare_table_columns" class="text-uppercase text-muted">Arbetstid</th>
                    </tr>
                    <tr>
                        <th colspan="6" style="text-align:right;">Ordinarie arbetstid:</th>
                        <th colspan="1" style="text-align:right;">{{ timecare_total_regular }}</th>
                        <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                    </tr>
                    <tr>
                        <th colspan="6" style="text-align:right;">Övertid:</th>
                        <th colspan="1" style="text-align:right;">{{ timecare_total_overtime }}</th>
                        <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                    </tr>
                    <tr>
                        <th colspan="6" style="text-align:right;">Total:</th>
                        <th colspan="1" style="text-align:right;">{{ timecare_total }}</th>
                        <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                    </tr>
                </template>
                <tr v-if="Object.keys(workhours_per_store).length" class="bg-light border-top">
                    <th :colspan="timecare_table_columns" class="text-uppercase text-muted">Arbetsplatser</th>
                </tr>
                <tr v-for="storeId in Object.keys(workhours_per_store)" :key="'s-' + storeId">
                    <th colspan="6" style="text-align:right;">{{ workhours_per_store[storeId].name }}:</th>
                    <th colspan="1" style="text-align:right;">{{ workhours_per_store[storeId].workhours.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</th>
                    <th :colspan="1 + (show_overtime ? 1 : 0) + (can_approve ? 2 : 0)" style="text-align:right;"></th>
                </tr>
                </tfoot>
            </table>
        </div>
        <div class="card-header bg-white border-top pt-5">
            <h5 class="card-title">Importera från kalender</h5>
        </div>
        <table class="table mb-3 border-bottom">
            <thead>
            <tr>
                <th>Datum</th>
                <th>Tid</th>
                <th>Typ</th>
                <th>Info</th>
                <th>Skapad av</th>
                <th class="text-right">
                    <button v-if="calendar_items.length > 0" class="btn btn-light btn-sm py-1" @click="selectAllCalEvents">Markera alla</button>
                </th>
            </tr>
            </thead>
            <tbody v-if="calendar_items.length > 0">
            <tr v-for="(calendar_item, ci_idx) in calendar_items" :class="{ 'bg-info-100': add_calendar_items_to_timecare.includes(ci_idx), 'bg-warning-100': calendar_item.has_timecare_items }" :key="ci_idx">
                <td>{{ calendar_item.calendar_date }} {{calendar_item.weekday }}</td>
                <td>{{ calendar_item.StartTS }} -- {{ calendar_item.EndTS }}</td>
                <td>{{ calendar_item.Type }}</td>
                <td>{{ calendar_item.ItemHeader }}</td>
                <td>{{ calendar_item.created_by }}</td>
                <td class="text-right">
                    <div class="badge badge-warning mr-2" :class="{ 'd-none':!calendar_item.has_timecare_items}"><i class="icon-warning mr-2"></i>Tillagd!</div>
                    <div class="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" class="custom-control-input" :id="'chk-addcal-' + ci_idx" :value="ci_idx" v-model="add_calendar_items_to_timecare">
                        <label class="custom-control-label" :for="'chk-addcal-' + ci_idx">LÄGG TILL</label>
                    </div>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5"><i>Inget händelser i kalendern...</i></td>
                </tr>
            </tbody>
        </table>
        <div class="px-3 text-right" v-if="calendar_items.length > 0">
            <limitless-button btn-class="btn-light" @click="addFromCalendar" :busy="busy_importing" icon="icon-plus3" saved-text="TILLAGT!">Lägg till markerade</limitless-button>
        </div>
        <div id="modal_timecare" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="timecare">
                    <div class="modal-header">
                        <h5 v-if="timecare.TimeCareID>0" class="modal-title">Redigera tidrad</h5>
                        <h5 v-else class="modal-title">Ny tidrad</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <ValidationObserver ref="timecareform">
                            <form @submit.prevent="saveTimecare">
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Börjat: <span class="text-danger">*</span></label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="TimeIN_date" name="Start datum" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <v-date-picker v-model="timecare.TimeIN_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                    <template v-slot="{ inputValue, togglePopover }">
                                                        <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                    </template>
                                                </v-date-picker>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                <span class="text-muted">Ursprunglig tid: {{ formatDateTime(timecare.TimeIN_org) }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-lg-3">
                                        <ValidationProvider vid="TimeIN_time" name="Start tid" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="time" class="form-control" v-model="timecare.TimeIN_time" :disabled="timecare_fullday" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-lg-3">
                                        <div class="form-check">
                                            <label class="form-check-label" style="padding-top: 8px;">
                                                <input type="checkbox" class="form-check-input" v-model="timecare_fullday">
                                                Heldag
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-form-label col-lg-2">Slutat:</label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="end_date" name="End date" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <v-date-picker v-model="timecare.TimeOUT_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                    <template v-slot="{ inputValue, togglePopover }">
                                                        <div class="input-group">
                                                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                            <span class="input-group-append">
                                                                <button class="btn btn-light" type="button" @click="timecare.TimeOUT_date = ''"><i class="icon-cross3"></i></button>
                                                            </span>
                                                        </div>
                                                    </template>
                                                </v-date-picker>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                <span class="text-muted">Ursprunglig tid: {{ formatDateTime(timecare.TimeOUT_org) }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-lg-3">
                                        <ValidationProvider vid="end_time" name="End time" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <input type="time" class="form-control" v-model="timecare.TimeOUT_time" :disabled="timecare_fullday" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="input-group-append">
                                                        <button class="btn btn-light" type="button" @click="timecare.TimeOUT_time = ''"><i class="icon-cross3"></i></button>
                                                    </span>
                                                </div>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-form-label col-lg-2">Rast: <span class="text-danger">*</span></label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="BreakMinutes" name="Rast" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="number" step="15" min="0" class="form-control" v-model="timecare.BreakMinutes" :disabled="timecare_fullday" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                <span class="text-muted">Ursprunglig rast: {{ timecare.BreakMinutes_org }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-form-label col-lg-2">Frånvaro: <span class="text-danger">*</span></label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="CauseCode" name="Frånvaro" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <cause-code-filter
                                                    v-model="timecare.CauseCode"
                                                    placeholder="--- EJ FRÅNVARO ---"
                                                    :reduce="opt => opt.id"
                                                    :class="{'has-validation-error':(!!errors[0])}"
                                                ></cause-code-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-form-label col-lg-2" style="padding-top: 36px;">Butik/Arbetsplats:</label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="StoreID" name="Butik IN" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label>Incheckning</label>
                                                <store-filter
                                                    :filter="(opt) => opt.is_workplace"
                                                    v-model="timecare.StoreID"
                                                    placeholder="--- Ej vald ---"
                                                    label="StoreName"
                                                    :reduce="opt => opt.StoreID"
                                                    :class="{'has-validation-error':(!!errors[0])}"
                                                ></store-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="StoreIDOut" name="Butik UT" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label>Utcheckning</label>
                                                <store-filter
                                                    :filter="(opt) => opt.is_workplace"
                                                    v-model="timecare.StoreIDOut"
                                                    placeholder="--- Ej vald ---"
                                                    label="StoreName"
                                                    :reduce="opt => opt.StoreID"
                                                    :class="{'has-validation-error':(!!errors[0])}"
                                                ></store-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div v-if="can_edit" class="row">
                                    <label class="col-form-label col-lg-2">Kommentar:</label>
                                    <div class="col-lg-8">
                                        <ValidationProvider vid="Comment" name="Kommentar" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <elastic-textarea class="form-control" v-model="timecare.Comment"></elastic-textarea>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div v-if="hasPermission('red_fortnox_integration')" class="row">
                                    <label class="col-form-label col-lg-2">OB:</label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="give_ob" name="Frånvaro" rules="" v-slot="{ errors }">
                                            <div class="form-check">
                                                <label class="form-check-label" style="padding-top: 8px;">
                                                    <input type="checkbox" class="form-check-input" v-model="timecare.give_ob" :true-value="1" :false-value="0">
                                                    Ska ha OB efter kl 18.00
                                                </label>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div v-if="can_approve" class="row">
                                    <label class="col-form-label col-lg-2">Godkänd:</label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="approved" name="Frånvaro" rules="" v-slot="{ errors }">
                                            <div class="form-check">
                                                <label class="form-check-label" style="padding-top: 8px;">
                                                    <input type="checkbox" class="form-check-input" v-model="timecare.approved" :true-value="1" :false-value="0">
                                                    Godkänd
                                                </label>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div v-if="edit_user.FortnoxSalaryType === 1 && hasPermission('red_fortnox_integration')" class="row">
                                    <label class="col-form-label col-lg-2">Fortnox:</label>
                                    <div class="col-lg-4">
                                        <ValidationProvider vid="overtime" name="Övertid" rules="" v-slot="{ errors }">
                                            <div class="form-check">
                                                <label class="form-check-label" style="padding-top: 8px;">
                                                    <input type="checkbox" class="form-check-input" v-model="timecare.overtime" :true-value="1" :false-value="0">
                                                    Överförs till Fortnox (Övertid)
                                                </label>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="text-muted mt-4">Skapad {{ formatDateTime(timecare.created_at) }}<span v-if="timecare.created_by_user"> av {{ timecare.created_by_user.name }}</span></div>
                                <div class="text-muted">Senast ändrad {{ formatDateTime(timecare.updated_at) }}<span v-if="timecare.updated_by_user"> av {{ timecare.updated_by_user.name }}</span></div>
                            </form>
                        </ValidationObserver>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeletetimecare" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteTimecare" :busy="timecare_saving">RADERA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsavetimecare" type="button" @click="saveTimecare" :busy="timecare_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Redigera tidrad</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->
    </div>
</template>
<script>
import LimitlessButton from '@components/Limitless/LimitlessButton';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import vSelect from 'vue-select';
import { formatDateTime, getDayName, hasPermission } from '@services/Helpers';
import getError from '@services/ErrorHelper';
import apiClient from '@services/ApiClient';
import ElasticTextarea from '@components/ElasticTextarea';
import CauseCodeFilter from '@components/Filters/CauseCodeFilter.vue';
import StoreFilter from '@components/Filters/StoreFilter.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';
import toast from 'not-a-toast';

export default {
    name: 'TimeCareForm',
    props: {
        id: {
            type: [String, Number],
            default: 0,
        },
        stores: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    components: {
        StoreFilter,
        CauseCodeFilter,
        ElasticTextarea,
        LimitlessButton,
        VDatePicker,
        vSelect,
    },
    data() {
        return {
            edit_user: null,
            busy_loading: false,
            busy_importing: false,
            timecare_loading: false,
            timecare_saving: false,
            calendar_items: [],
            add_calendar_items_to_timecare: [],
            timecare_period: '',
            timecare: null,
            timecare_fullday: false,
            timecares: [],
            saving_overtime_ids: [],
        };
    },
    mounted() {
        this.getUser();

        const firstDayOfMonth = new Date();
        if (firstDayOfMonth.getDate() < 20) {
            this.timecare_period = this.select_timecard_periods[this.select_timecard_periods.length - 2].id;
        } else {
            this.timecare_period = this.select_timecard_periods[this.select_timecard_periods.length - 1].id;
        }
    },
    watch: {
        timecare_period() {
            if (this.edit_user) {
                this.getUserTimecare();
            }
        },
        timecare_fullday(val) {
            if (val) {
                this.timecare.TimeIN_time = '08:00';
                this.timecare.TimeOUT_time = '17:00';
                this.timecare.TimeOUT_date = this.timecare.TimeIN_date;
                this.timecare.BreakMinutes = 60;
            }
        },
        'timecare.TimeOUT_date': function timecareTimeOutDate(val) {
            if (this.timecare && this.timecare_fullday && this.timecare.TimeIN_date !== val) {
                this.timecare.TimeIN_date = val;
            }
        },
        'timecare.TimeIN_date': function timecareTimeInDate(val) {
            if (this.timecare && this.timecare_fullday && this.timecare.TimeOUT_date !== val) {
                this.timecare.TimeOUT_date = val;
            }
        },
    },
    methods: {
        formatDateTime,
        getDayName,
        hasPermission,
        workedTimeHundredths(time) {
            const workedTime = parseFloat(time.WorkedTime);
            return Number.isFinite(workedTime) ? Math.round(workedTime * 100) : 0;
        },
        formatTimeHundredths(hundredths) {
            return (hundredths / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getUser() {
            this.busy_loading = true;
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.edit_user = response.data.user;
                    this.getUserTimecare();
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async getUserTimecare() {
            const datefilter = this.timecare_period.split('_');
            await apiClient.get('/vue/users/' + this.edit_user.UserID + '/timecares?get_calendar_items=1&date_from=' + datefilter[0] + '&date_to=' + datefilter[1])
                .then((response) => {
                    this.timecares = response.data.timecares;
                    if (response.data.calendar_items) {
                        this.calendar_items = response.data.calendar_items;
                    } else {
                        this.calendar_items = [];
                    }
                });
        },
        async addFromCalendar() {
            this.busy_importing = true;
            let errorMessage = '';
            // eslint-disable-next-line no-restricted-syntax
            for (const idx of this.add_calendar_items_to_timecare) {
                const causeCodes = {
                    6: 'VAB', 7: 'SJK', 8: 'SEM', 9: 'FPE', 10: 'TJL', 11: 'PEM',
                };
                const startStr = this.calendar_items[idx].StartTS;
                const endStr = this.calendar_items[idx].EndTS;
                let breakTime = 60;

                const st = startStr.split(/[- :]/);
                const startDate = new Date(Date.UTC(st[0], st[1] - 1, st[2], st[3], st[4], st[5]));
                const et = endStr.split(/[- :]/);
                const endDate = new Date(Date.UTC(et[0], et[1] - 1, et[2], et[3], et[4], et[5]));
                const noonDate = new Date(endDate.getTime());
                noonDate.setHours(12);
                noonDate.setMinutes(30);
                if (endDate.getTime() < noonDate.getTime()) {
                    breakTime = 0;
                }

                const timecare = {
                    UserID: this.edit_user.UserID,
                    TimeIN: startDate.toISOString(),
                    TimeIN_org: startDate.toISOString(),
                    TimeOUT: endDate.toISOString(),
                    TimeOUT_org: endDate.toISOString(),
                    BreakMinutes: breakTime,
                    BreakMinutes_org: breakTime,
                    SickLeave: (this.calendar_items[idx].TypeID === 7 ? 1 : 0),
                    CauseCode: causeCodes[this.calendar_items[idx].TypeID],
                    approved: 1,
                    StoreID: this.edit_user.StoreID,
                    from_calendar: true,
                };
                // eslint-disable-next-line no-await-in-loop
                await apiClient.post('/vue/users/' + this.edit_user.UserID + '/timecares/0', timecare)
                    // eslint-disable-next-line no-loop-func
                    .catch((error) => {
                        const { status } = error.response;
                        const { data } = error.response;
                        if (status === 422) {
                            if (data.errors && data.errors.TimeIN_date) {
                                errorMessage += timecare.TimeIN.substring(0, 10) + ': ' + data.errors.TimeIN_date + '<br>';
                            } else {
                                errorMessage += timecare.TimeIN.substring(0, 10) + ': Okänt fel...<br>';
                            }
                        }
                    });
            }
            this.add_calendar_items_to_timecare = [];
            await this.getUserTimecare();
            this.busy_importing = false;
            if (errorMessage) {
                this.$swal({
                    title: 'Fel vid import från kalender',
                    html: '<div style="text-align: left; font-size: 16px;">' + errorMessage + '</div>',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                });
            }
        },
        async approveTime(time) {
            const timecare = JSON.parse(JSON.stringify(time));
            let doApprove = false;
            await this.$swal({
                text: 'Vill du godkänna denna tidrad?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, godkänn!',
            }).then((result) => {
                if (result.isConfirmed) {
                    doApprove = true;
                }
            });
            if (doApprove) {
                timecare.approved = 1;
                await apiClient.post('/vue/users/' + this.edit_user.UserID + '/timecares/' + timecare.TimeCareID, timecare)
                    .finally(() => {
                        this.getUserTimecare();
                    });
            }
        },
        async saveOvertime(time) {
            const previousOvertime = time.overtime ? 0 : 1;
            const timecareIndex = this.timecares.findIndex((item) => item.TimeCareID === time.TimeCareID);
            this.saving_overtime_ids.push(time.TimeCareID);

            const t = toast({
                message: 'Sparar...',
                theme: 'limitlessInfo',
                duration: 0,
                showIcon: true,
                iconType: 'loader',
                position: 'top-right',
            });
            await apiClient.post('/vue/users/' + this.edit_user.UserID + '/timecares/' + time.TimeCareID, time)
                .then((response) => {
                    this.$set(this.timecares[timecareIndex], 'overtime', response.data.timecare.overtime);
                    this.$set(this.timecares[timecareIndex], 'SentToFortnox', response.data.timecare.SentToFortnox);
                    t.update({
                        message: 'Sparad!',
                        duration: 3000,
                        autoClose: true,
                        pauseOnHover: true,
                        theme: 'limitlessSuccess',
                        iconType: 'success',
                    });
                })
                .catch((error) => {
                    this.$set(this.timecares[timecareIndex], 'overtime', previousOvertime);
                    const parsederror = getError(error);
                    t.update({
                        message: 'Kunde inte spara övertid! ' + (typeof parsederror === 'string' ? parsederror : 'Ett oväntat fel inträffade.'),
                        duration: 3000,
                        autoClose: true,
                        pauseOnHover: true,
                        theme: 'limitlessDanger',
                        iconType: 'error',
                    });
                })
                .finally(() => {
                    this.saving_overtime_ids = this.saving_overtime_ids.filter((id) => id !== time.TimeCareID);
                });
        },
        editTimecare(timecareID) {
            this.timecare_loading = true;
            $('#modal_timecare').modal('show');
            apiClient.get('/vue/users/' + this.edit_user.UserID + '/timecares/' + timecareID)
                .then((response) => {
                    const { timecare } = response.data;
                    if (timecare.TimeIN) {
                        const timeIn = formatDateTime(timecare.TimeIN);
                        timecare.TimeIN_date = timeIn.substr(0, 10);
                        timecare.TimeIN_time = timeIn.substr(11, 5);
                    } else {
                        timecare.TimeIN_date = '';
                        timecare.TimeIN_time = '';
                    }
                    if (timecare.TimeOUT) {
                        const timeOut = formatDateTime(timecare.TimeOUT);
                        timecare.TimeOUT_date = timeOut.substr(0, 10);
                        timecare.TimeOUT_time = timeOut.substr(11, 5);
                    } else {
                        timecare.TimeOUT_date = '';
                        timecare.TimeOUT_time = '';
                    }
                    if (timecare.TimeIN_time === '08:00' && timecare.TimeOUT_time === '17:00' && timecare.BreakMinutes === 60 && timecare.TimeIN_date === timecare.TimeOUT_date) {
                        this.timecare_fullday = true;
                    } else {
                        this.timecare_fullday = false;
                    }
                    this.timecare = timecare;
                })
                .finally(() => {
                    this.timecare_loading = false;
                });
        },
        async saveTimecare() {
            const isValid = await this.$refs.timecareform.validate();
            if (isValid) {
                this.timecare_saving = true;
                if (this.timecare.TimeIN_date && this.timecare.TimeIN_time) {
                    const startStr = this.timecare.TimeIN_date + ' ' + this.timecare.TimeIN_time + ':00';
                    const st = startStr.split(/[- :]/);
                    const startDate = new Date(Date.UTC(st[0], st[1] - 1, st[2], st[3], st[4], st[5]));
                    this.timecare.TimeIN = startDate.toISOString();
                } else {
                    this.timecare.TimeIN = '';
                }
                if (this.timecare.TimeOUT_date && this.timecare.TimeOUT_time) {
                    const endStr = this.timecare.TimeOUT_date + ' ' + this.timecare.TimeOUT_time + ':00';
                    const et = endStr.split(/[- :]/);
                    const endDate = new Date(Date.UTC(et[0], et[1] - 1, et[2], et[3], et[4], et[5]));
                    this.timecare.TimeOUT = endDate.toISOString();
                } else {
                    this.timecare.TimeOUT = '';
                }
                await apiClient.post('/vue/users/' + this.edit_user.UserID + '/timecares/' + this.timecare.TimeCareID, this.timecare)
                    .then((response) => {
                        const { timecare } = response.data;
                        if (timecare.TimeIN) {
                            const timeIn = formatDateTime(timecare.TimeIN);
                            timecare.TimeIN_date = timeIn.substr(0, 10);
                            timecare.TimeIN_time = timeIn.substr(11, 5);
                        } else {
                            timecare.TimeIN_date = '';
                            timecare.TimeIN_time = '';
                        }
                        if (timecare.TimeOUT) {
                            const timeOut = formatDateTime(timecare.TimeOUT);
                            timecare.TimeOUT_date = timeOut.substr(0, 10);
                            timecare.TimeOUT_time = timeOut.substr(11, 5);
                        } else {
                            timecare.TimeOUT_date = '';
                            timecare.TimeOUT_time = '';
                        }
                        if (timecare.TimeIN_time === '08:00' && timecare.TimeOUT_time === '17:00' && timecare.BreakMinutes === 60 && timecare.TimeIN_date === timecare.TimeOUT_date) {
                            this.timecare_fullday = true;
                        } else {
                            this.timecare_fullday = false;
                        }
                        this.timecare = timecare;
                        this.$refs.btnsavetimecare.triggerSaved();
                        this.getUserTimecare();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.timecareform.setErrors(parsederror);
                        }
                        this.$refs.btnsavetimecare.triggerFailed();
                    })
                    .finally(() => {
                        this.timecare_saving = false;
                    });
            }
        },
        deleteTimecare() {
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Är du säker på att du vill ta bort denna tidrad?')) {
                this.timecare_saving = true;
                apiClient.delete('/vue/users/' + this.edit_user.UserID + '/timecares/' + this.timecare.TimeCareID)
                    .then(() => {
                        $('#modal_timecare').modal('hide');
                        this.getUserTimecare();
                        this.timecare = null;
                    })
                    .catch(() => {
                        this.$refs.btndeletetimecare.triggerFailed();
                    })
                    .finally(() => {
                        this.timecare_saving = false;
                    });
            }
        },
        selectAllCalEvents() {
            this.calendar_items.forEach((ci, idx) => {
                if (!ci.has_timecare_items && !this.add_calendar_items_to_timecare.includes(idx)) {
                    this.add_calendar_items_to_timecare.push(idx);
                }
            });
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        can_edit() {
            return this.edit_user && this.user && (hasPermission('red_edit_all_users')
                || (hasPermission('red_edit_users_timecare') && this.edit_user.UserID !== this.user.id)
                || (hasPermission('red_edit_own_timecare') && this.edit_user.UserID === this.user.id));
        },
        can_approve() {
            return this.edit_user && this.user && (hasPermission('red_edit_all_users')
                || (hasPermission('red_edit_users_timecare') && this.edit_user.UserID !== this.user.id)
                || (hasPermission('red_edit_users_timecare') && hasPermission('red_edit_own_timecare') && this.edit_user.UserID === this.user.id));
        },
        show_overtime() {
            return this.edit_user && this.edit_user.FortnoxSalaryType === 1 && hasPermission('red_fortnox_integration');
        },
        timecare_table_columns() {
            return 8 + (this.show_overtime ? 1 : 0) + (this.can_approve ? 2 : 0);
        },
        select_timecard_periods() {
            const months = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
            const arr = [];
            const startDate = new Date();
            const endDate = new Date();
            startDate.setDate(16);
            startDate.setMonth(startDate.getMonth() - 12);
            endDate.setDate(15);
            endDate.setMonth(endDate.getMonth() - 11);
            let startStr = '';
            let endStr = '';
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i <= 12; i++) {
                if (endDate.getFullYear() === 2025 && (endDate.getMonth() + 1) === 2 && endDate.getDate() === 15) {
                    startStr = startDate.getFullYear() + '-' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '-' + startDate.getDate();
                    endStr = endDate.getFullYear() + '-' + (endDate.getMonth() + 1).toString().padStart(2, '0') + '-' + (endDate.getDate() - 2);
                } else if (startDate.getFullYear() === 2025 && (startDate.getMonth() + 1) === 2 && startDate.getDate() === 16) {
                    startStr = startDate.getFullYear() + '-' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '-' + (startDate.getDate() - 2);
                    endStr = endDate.getFullYear() + '-' + (endDate.getMonth() + 1).toString().padStart(2, '0') + '-' + endDate.getDate();
                } else {
                    startStr = startDate.getFullYear() + '-' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '-' + startDate.getDate();
                    endStr = endDate.getFullYear() + '-' + (endDate.getMonth() + 1).toString().padStart(2, '0') + '-' + endDate.getDate();
                }
                arr.push({ id: startStr + '_' + endStr, label: months[endDate.getMonth()] + ' (' + startStr + ' - ' + endStr + ')' });
                startDate.setMonth(startDate.getMonth() + 1);
                endDate.setMonth(endDate.getMonth() + 1);
            }
            return arr;
        },
        timecare_total_unpaid() {
            const reducer = (previousValue, time) => previousValue + (time.PayslipID === 0 && time.SentToFortnox === 0 ? this.workedTimeHundredths(time) : 0);
            return this.formatTimeHundredths(this.timecares.reduce(reducer, 0));
        },
        timecare_total_paid() {
            const reducer = (previousValue, time) => previousValue + (time.PayslipID === 0 && time.SentToFortnox === 0 ? 0 : this.workedTimeHundredths(time));
            return this.formatTimeHundredths(this.timecares.reduce(reducer, 0));
        },
        timecare_total_regular() {
            const reducer = (previousValue, time) => previousValue + (Number(time.overtime) === 0 ? this.workedTimeHundredths(time) : 0);
            return this.formatTimeHundredths(this.timecares.reduce(reducer, 0));
        },
        timecare_total_overtime() {
            const reducer = (previousValue, time) => previousValue + (Number(time.overtime) > 0 ? this.workedTimeHundredths(time) : 0);
            return this.formatTimeHundredths(this.timecares.reduce(reducer, 0));
        },
        timecare_total() {
            const reducer = (previousValue, time) => previousValue + this.workedTimeHundredths(time);
            return this.formatTimeHundredths(this.timecares.reduce(reducer, 0));
        },
        workhours_per_store() {
            const workplaces = {};
            this.timecares.forEach((time) => {
                const storeId = time.StoreID ?? time.StoreIDOut ?? 0;
                const storName = time.StoreNameIn ?? time.StoreNameOut ?? 'Okänd arbetsplats';
                if (!workplaces[storeId]) {
                    workplaces[storeId] = {
                        name: storName,
                        workhours_hundredths: 0,
                    };
                }

                workplaces[storeId].workhours_hundredths += this.workedTimeHundredths(time);
            });
            Object.keys(workplaces).forEach((storeId) => {
                workplaces[storeId].workhours = workplaces[storeId].workhours_hundredths / 100;
            });
            return workplaces;
        },
    },
};
</script>
